<template>
  <vbt-dialog
    v-model="dialog"
    title="Create location"
    width="500px"
    submit-btn-name="Create"
    @submit="submitForm"
    @close="onDialogClose"
  >
    <v-form :ref="formRef">
      <v-text-field
        v-model.trim="form.name"
        :rules="validator.getRulesByField('name')"
        label="Name"
        @keypress.enter="submitForm"
      />
      <v-text-field
        v-model.trim="form.route"
        :rules="validator.getRulesByField('route')"
        label="Route"
        @keypress.enter="submitForm"
      />
    </v-form>
  </vbt-dialog>
</template>

<script>
import { useDialog, useEditor, useFormWithRef } from '@mixins/factories';

import { Validator, wrapToLoadingFn } from '@helpers';

import LocationsApiService from '../_services/locations.api.service';

import { generateLocationModel } from '../_models/location.model';

const editorOptions = { formGenerator: generateLocationModel };

const validator = Validator.createValidator({
  name: ['required'],
  route: ['required'],
});

export default {
  name: 'UmsLocationEditor',
  mixins: [
    useDialog(),
    useFormWithRef(),
    useEditor(editorOptions),
    Validator.useValidator(validator),
  ],
  methods: {
    wrapToLoadingFn,
    submitForm() {
      if (!this.$_validateForm()) {
        return;
      }

      this.$VBlackerTheme.alert.warning({
        text: 'Create location?',
      }, () => this.wrapToLoadingFn({
        req: LocationsApiService.createLocation.bind({}, this.form),
        fullscreenLoadingSpinner: true,
        onSuccess: () => {
          this.$VBlackerTheme.notification.success('Location successfully created');
          this.$emit('change:success');
        },
      }));
    },
    onDialogClose() {
      this.$nextTick(() => {
        this.$_resetFormValidation();
        this.$_resetForm();
      });
    },
  },
};
</script>
